export default __webpack_public_path__ + "static/media/logo-01.71004281.png";